import React, { useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "@/lib/toast";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Flag, AlertTriangle } from "lucide-react";

export function ReportOffPlatformButton({ username }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/users/${username}/report`, {
        category: "off_platform",
        reason: "Seller asked me to complete this sale off-platform",
        comment: note,
      });
      toast.success("Reported to our team. Thanks — this helps keep trades safe.");
      setOpen(false); setNote("");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="report-offplatform-btn" title="Report off-platform request"
          className="inline-flex items-center gap-1.5 border border-sniper hover:border-blaze text-muted-foreground hover:text-blaze font-mono uppercase text-[11px] px-2.5 py-1.5 transition-colors">
          <Flag className="w-3.5 h-3.5" /> Report
        </button>
      </DialogTrigger>
      <DialogContent className="bg-surface border-sniper text-foreground rounded-none" data-testid="report-offplatform-dialog">
        <DialogHeader><DialogTitle className="font-heading uppercase flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-blaze" /> Report off-platform request</DialogTitle></DialogHeader>
        <DialogDescription className="text-xs font-body text-secondary-foreground">
          Did @{username} ask you to complete this sale off OpticSwap — pay by cash, Venmo, or outside OpticSwap? That's against the rules and leaves you with no buyer protection. Report it and our team will review the conversation.
        </DialogDescription>
        <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} data-testid="report-offplatform-note"
          placeholder="What did they say? (optional)…" className="w-full bg-input border border-sniper focus:border-olive outline-none px-3 py-2.5 text-foreground transition-colors" />
        <DialogFooter>
          <button onClick={submit} disabled={busy} data-testid="report-offplatform-send"
            className="bg-blaze hover:brightness-110 text-black font-heading font-bold uppercase px-6 py-2.5 transition-colors disabled:opacity-50">{busy ? "Sending…" : "Submit report"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
